module.exports = __webpack_public_path__ + "static/img/fish18.9456cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish18.png
// module id = zLM1
// module chunks = 0